<template>
<div>

    <Collapse>
        <Panel :name="Section.Title">
			{{Section.Title}}
            <p slot="content">
				<FilterBucketItems :Items="Section.Items" :SelectedFilterOptions="SelectedFilterOptions" @changeBucket="changeBucket" />
			</p>
        </Panel>
	</Collapse>

</div>
</template>



<script>
import FilterBucketItems from './FilterBucketItems.vue';

export default {
	name: 'FilterContainer',
	components: { FilterBucketItems },
	methods: {
		changeBucket(r) {
            this.$emit('changeBucket', r);
		}
	},
	props: {
		Section: Object,
		SelectedFilterOptions: String
	}	
}
</script>
